import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";
import { useOp } from "../../lib/useOp";
import { fmt } from "../../lib/lm";
import { Btn, Card } from "../kit/Kit";

export const Cierres = ({ ds }) => {
  const [rows, setRows] = useState([]);
  const [cut, setCut] = useState("");
  const { run, bar, busy } = useOp("cierre-progress");
  const load = () => http.get("/lm/cierres", { params: { dataset: ds } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [ds]); // eslint-disable-line react-hooks/exhaustive-deps
  const cerrar = async () => {
    try { await run("Cierre mensual inmutable", (o) => http.post("/lm/cierres", { dataset: ds, cut }, o)); toast.success("Cierre congelado"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Cierres mensuales" subtitle="Snapshot inmutable por crédito (saldo, DPD, bucket, estatus, etapa) con huella SHA-256. No se puede repetir ni editar un corte." testid="cierres">
      <div className="flex flex-wrap items-center gap-3"><input type="date" value={cut} onChange={(e) => setCut(e.target.value)} data-testid="cierre-fecha" className="rounded-xl border border-[#E2DDD5] px-3 py-2 text-sm" />
        <Btn onClick={cerrar} disabled={!cut || busy} data-testid="cierre-crear">Congelar cierre</Btn></div>
      {bar}
      <table className="mt-4 w-full text-sm" data-testid="cierres-tabla"><thead className="text-left text-[10px] uppercase tracking-widest text-[#8C867A]"><tr><th className="py-2">Corte</th><th>Saldo</th><th>Por</th><th>Huella</th></tr></thead>
        <tbody>{rows.map((r) => <tr key={r.cut} className="border-t border-[#F2F0EC]"><td className="py-2 font-semibold">{r.cut}</td><td className="tabular-nums">{fmt(r.saldo)}</td><td>{r.by}</td><td className="font-mono text-xs">{r.hash?.slice(0, 16)}…</td></tr>)}
          {!rows.length && <tr><td colSpan={4} className="py-4 text-[#8C867A]">Sin cierres todavía.</td></tr>}</tbody></table>
    </Card>
  );
};
